import API from 'services/api';

export const getPartnerCardDetails = (calculationId: string) =>
  API.get(`/api/accommodation/calculations/${calculationId}/cardData`).then(
    response => response?.data,
  );
